import { render, staticRenderFns } from "./NewGroup.vue?vue&type=template&id=b2e7d2f8&scoped=true"
import script from "./NewGroup.vue?vue&type=script&lang=js"
export * from "./NewGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e7d2f8",
  null
  
)

export default component.exports